import React, { FunctionComponent, useState } from 'react';
import classNames from 'classnames';
import closeImage from '../../assets/close.png';
import eyePrimaryImage from '../../assets/eye-primary.png';
import { Button } from '../Input/Button/Button';
import styles from './styles.module.scss';

export const buildModalBreadcrumbs = (...steps: string[]) => (
  <div className="modal-breadcrumbs">
    {steps.map((step, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        {step}
        {index !== steps.length - 1 && <span className="separator">{'>'}</span>}
      </React.Fragment>
    ))}
  </div>
);

type Props = {
  // Button text/component to open Quick Guide
  action: string | React.ReactNode;
  guideTitle?: string;
  children: React.ReactNode;
  // Needed by Magnifier child components
  hasZoomedImage?: boolean;
  footerClose?: boolean;
} & (
  | {
      variant?: 'default';
      label: string;
    }
  | {
      // label isn't used for the minimal variant
      variant: 'minimal';
      label?: undefined;
    }
);

export const QuickGuide: FunctionComponent<Props> = ({
  label,
  action,
  variant,
  guideTitle,
  children,
  hasZoomedImage,
  footerClose,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.container}>
      {variant !== 'minimal' && <div className={styles.label}>{label}</div>}
      <Button
        className={styles.actionButton}
        variant="minimal"
        onClick={() => setOpen(true)}
      >
        {action}
      </Button>
      {open ? (
        <div className={styles.modal}>
          <Button
            className={styles.close}
            variant="minimal"
            onClick={() => setOpen(false)}
          >
            <img src={closeImage} alt="close" />
          </Button>
          <div
            className={classNames(
              styles.modalContent,
              hasZoomedImage && styles.zoomedImages,
            )}
          >
            {guideTitle && <div className="modal-title">{guideTitle}</div>}
            {children}
            {footerClose ? (
              <Button
                className={styles.closeFooter}
                label="Close"
                type="button"
                variant="primary"
                onClick={() => setOpen(false)}
              />
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

interface PreviewGuideProps extends Omit<Props, 'variant' | 'label'> {
  hideIcon?: boolean;
}

export const PreviewGuide: FunctionComponent<PreviewGuideProps> = ({
  action,
  guideTitle,
  children,
  footerClose,
  hideIcon,
}) => {
  const renderAction = () => (
    <>
      {!hideIcon ? (
        <img className={styles.previewIcon} src={eyePrimaryImage} alt="" />
      ) : null}
      {action}
    </>
  );
  return (
    <QuickGuide
      action={renderAction()}
      guideTitle={guideTitle}
      variant="minimal"
      footerClose={footerClose}
    >
      {children}
    </QuickGuide>
  );
};
